export const buttonVariants = {
  hover: {
    scale: 1.05,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  tap: {
    scale: 0.95,
  },
};
